export const PAGE_TITLE_NEW_CAR_PAST_CAR = 'All Past Cars';
export const RESULT_PER_PAGE_NUM_LIMIT = 15;
